export default {
  name: 'PrivacyPolicyIos',
  components: {}
};